<template>
    <v-dialog :value="dialog" fullscreen persistent hide-overlay transition="dialog-bottom-transition">
        <addEditPicking :activeTab="activeTab"></addEditPicking>
    </v-dialog>
</template>

<script>
    import addEditPicking from '../../Shared/AddPicking.vue'

    // Picking Types
    import {
        Picking
    } from '../../../store/namespace-helper'

    export default {
      name: 'picking-dialog',
      components: {
        addEditPicking
      },
      props: {
        activeTab: {
          type: Number,
          default: 0
        }
      },
      data () {
        return {}
      },
      methods: {},
      computed: {
        dialog () {
          return this.$store.getters[Picking.getters.getOpenDialogState]
        }
      },
      beforeDestroy () {

      }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/Invoices/Pickings/AddPickingDialog.vue